import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Divider,
} from '@mui/material';

const REMOVAL_STATUSES = [
    'Awaiting Pickup',
    'Listed',
    'Sold',
    'Missing',
    'Inspection',
    'Putaway',
    'Failed Inspection',
    'Returned',
    'Investigation Pending',
    'Reserves / Refurbish',
    'Scrapped',
    'Pending eBay',
    'Pending Walmart',
];

const DEFAULT_STATUS = 'Listed';

export default function RemoveCatalogItemDialog({
    open,
    items = [],
    onCancel,
    onConfirm,
    confirming = false,
}) {
    const [status, setStatus] = useState(DEFAULT_STATUS);

    useEffect(() => {
        if (open) setStatus(DEFAULT_STATUS);
    }, [open]);

    const labels = items
        .map((item) => item?.itemId || item?._id)
        .filter(Boolean);

    return (
        <Dialog open={open} onClose={confirming ? undefined : onCancel} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ padding: '10px 15px 5px 15px' }}>
                Remove catalog item?
            </DialogTitle>
            <Divider sx={{ borderColor: 'black' }} />
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {labels.length === 1 ? (
                        <>
                            Remove <strong>{labels[0]}</strong> from this order/shipment?
                        </>
                    ) : (
                        <>
                            Remove <strong>{labels.length}</strong> catalog items from this
                            order/shipment?
                        </>
                    )}
                </Typography>
                {labels.length > 1 && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        {labels.join(', ')}
                    </Typography>
                )}
                <FormControl fullWidth sx={{ mt: 2 }} size="small">
                    <InputLabel id="removal-status-label">New item status</InputLabel>
                    <Select
                        labelId="removal-status-label"
                        id="removal-status-select"
                        value={status}
                        label="New item status"
                        disabled={confirming}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {REMOVAL_STATUSES.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 2, pb: 1.5 }}>
                <Button onClick={onCancel} disabled={confirming} sx={{ textTransform: 'none' }}>
                    Cancel
                </Button>
                <Button
                    color="error"
                    variant="contained"
                    disableElevation
                    disabled={confirming || !status}
                    onClick={() => onConfirm(status)}
                    sx={{ textTransform: 'none' }}
                >
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );
}
